import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import MenuCategoriesTab from './components/MenuCategoriesTab';
import MenuItemsTab from './components/MenuItemsTab';
import LiveOrdersTab from './components/LiveOrdersTab';
import OperatingHoursTab from './components/OperatingHoursTab';
import TablesTab from './components/TablesTab';
import RevenueReportTab from './components/RevenueReportTab';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div role="tabpanel" hidden={value !== index} {...other}>
            {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
        </div>
    );
}

export default function RestaurantManagement() {
    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
                <Typography variant="h4" fontWeight="bold">Restaurant & Menu</Typography>
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: '#eaecf0', mb: 3 }}>
                <Tabs 
                    value={tabValue} 
                    onChange={handleTabChange} 
                    variant="scrollable" 
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                >
                    <Tab label="Menu Catalogue" />
                    <Tab label="Menu Categories" />
                    <Tab label="Live Orders" />
                    <Tab label="Table Management" />
                    <Tab label="Operating Hours" />
                    <Tab label="Financial Analytics" />
                </Tabs>
            </Box>
                
            <Box>
                    {/* Menu Catalogue */}
                    <TabPanel value={tabValue} index={0}>
                        <MenuItemsTab />
                    </TabPanel>

                    {/* Menu Categories */}
                    <TabPanel value={tabValue} index={1}>
                        <MenuCategoriesTab />
                    </TabPanel>

                    {/* Live Orders */}
                    <TabPanel value={tabValue} index={2}>
                        <LiveOrdersTab />
                    </TabPanel>

                    {/* Table Management */}
                    <TabPanel value={tabValue} index={3}>
                        <TablesTab />
                    </TabPanel>

                    {/* Operating Hours */}
                    <TabPanel value={tabValue} index={4}>
                        <OperatingHoursTab />
                    </TabPanel>

                    {/* Financial Analytics */}
                    <TabPanel value={tabValue} index={5}>
                        <RevenueReportTab />
                    </TabPanel>
                </Box>
        </Box>
    );
}
